<template>
  <b-form-group
    label="Sektör"
    label-for="id_sectors"
  >
    <validation-provider
      #default="{ errors }"
      name="Sektör"
      rules="required"
    >
      <v-select
        id="id_sectors"
        v-model="dataItem.id_sectors"
        :options="sectors"
        label="title"
        :reduce="sector => sector.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Sector',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
    sectors() {
      return this.$store.getters['sectors/dataList']
    },
  },
  created() {
    this.getSectors()
    localize('tr')
  },
  methods: {
    getSectors() {
      this.$store.dispatch('sectors/getDataList', {
        select: [
          'sectors.id AS id',
          'sectors.title AS title',
        ],
      })
    },
  },
}
</script>
